import FileSaver from 'file-saver'
import utils from '@/utils/utils'

export default {
  computed: {
    canDownload: function () {
      return !!this.fileContent
    }
  },
  methods: {
    download: function () {
      if (this.fileContent) {
        let date = utils.dateToString(new Date()).split('/').join('').split(':').join('').split('-').join('')
        date = date.replace(/\s/g, '')
        let filename =     'mandate' + date + '.pdf'
        var blob = this.base64ToBlob(this.fileContent, 'application/octet-stream')
        FileSaver.saveAs(blob, filename)
      }

    },
    base64ToBlob: function (base64) {
      var binary = atob(base64)
      var array = new Uint8Array(binary.length)
      for( var i = 0; i < binary.length; i++ ) { array[i] = binary.charCodeAt(i) }
      return new Blob([array])
    }
  },
  data: function () {
    return {
      fileContent: ''
    }
  }
}